import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { DEVICE_INFO_API_URL } from '../../config';
import userAxios from './user.axios';
import Cookies from 'js-cookie';

const axiosConfig: AxiosRequestConfig = {
    baseURL: `${DEVICE_INFO_API_URL}` || 'http://localhost:3000/',
};

const deviceInfoAxios = axios.create(axiosConfig);

const logout = () => {
    Cookies.remove('accessToken');
    Cookies.remove('refreshToken');
    Cookies.remove('user');
    Cookies.remove('role');
    window.location.reload();
    // (window as any).Intercom('shutdown');
};

// reqeust intercpetor
deviceInfoAxios.interceptors.request.use((config) => {
    const token = Cookies.get('accessToken');
    // const isValid = validateJWT(token);
    if (token) {
        return {
            ...config,
            headers: {
                'Access-Control-Allow-Origin': '*',
                Authorization: `Bearer ${token}`,
            },
        };
    }
    return config;
});

// Add a response interceptor
deviceInfoAxios.interceptors.response.use(
    (response) => {
        if (response?.data?.error === 'No permission!') logout();
        return response;
    },
    async (error) => {
        const err = { ...error };
        if (error.response.status === 401) {
            const err = { ...error };
            const originalRequest = err.config;
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    const token = Cookies.get('refreshToken');
                    const response = await userAxios.post('/dom/refresh-token', { token });
                    const accessToken = response.data.data.token;
					Cookies.set('accessToken', accessToken, { 
						path: '/',
						secure: true,
						sameSite: 'None',
					});
                    axios.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
                    return userAxios(originalRequest);
                } catch (e) {
                    console.error(e);
                    logout();
                }
            } else {
                logout();
            }
        }
        return Promise.reject(err);
    },
);

export const deviceInfoAxiosQuery =
    (): BaseQueryFn<{
        url: string;
        method: AxiosRequestConfig['method'];
        data?: AxiosRequestConfig['data'];
    }> =>
        async ({ url, method, data }) => {
            const baseUrl = axiosConfig.baseURL;
            try {
                const result = await deviceInfoAxios({ url: baseUrl + url, method, data });
                return { data: result.data };
            } catch (axiosError) {
                const err = axiosError as AxiosError;
                return {
                    error: { status: err.response?.status, data: err.response?.data },
                };
            };
        };

export default deviceInfoAxios;
